export default "__VITE_ASSET__CLR4il7$__"